import { ReactNode } from 'react';

interface POSLayoutProps {
  header: ReactNode;
  cart: ReactNode;
  children: ReactNode;
}

export const POSLayout = ({ header, cart, children }: POSLayoutProps) => {
  return (
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        {header}

        {/* Main Content - Products & Categories */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>

      {/* Cart Sidebar */}
      <div className="w-96 bg-card border-l border-border shadow-lg flex flex-col">
        {cart}
      </div>
    </div>
  );
};
